import React from "react";
import "./OpenSchoolSection.css";
import { useNavigate } from "react-router-dom";

const OpenSchoolSection = ({
	title = "みんなに開かれた学校",
	subtitle = "あなたの現在の状況に関わらず、未来への扉を開きます",
}) => {
	const navigate = useNavigate();
	const cards = [
		{
			icon: "school",
			tint: "green",
			title: "今高校や大学に通っていない",
			desc: `
				不登校でも<span class="highlight">自宅から学習できる環境</span>を提供。
				<span class="big-text">就労継続支援A型施設と連携</span>し、
				ゆっくりと社会に出る方法も選択できます。
			`,
		},
		{
			icon: "cap",
			tint: "blue",
			title: "高校に通っていて、進路を考えている",
			desc: `
				将来のキャリアを見据えた<span class="highlight">実践的なスキル</span>を習得。
				<span class="big-text">起業家</span>として羽ばたくことも可能です。
			`,
		},
		{
			icon: "building",
			tint: "purple",
			title: "大学に通っているが、スキルをつけたい",
			desc: `
				大学の学習と並行して、<span class="highlight">実務に直結するスキル</span>を習得。
				<span class="big-text">就職活動で差をつける</span>ことができます。
			`,
		},
	];

	return (
		<div className="openAll" aria-labelledby="openAll-title">
			<div className="openAll__head">
				<h2 id="openAll-title" className="openAll__title">{title}</h2>
				<p className="openAll__sub">{subtitle}</p>
			</div>

			<div className="openAll__grid">
				{cards.map((c, i) => (
					<article key={i} className="openCard">
						<div className={`openCard__icon openCard__icon--${c.tint}`} aria-hidden="true">
							<Icon name={c.icon} />
						</div>
						<h3 className="openCard__title">{c.title}</h3>
						<p
							className="openCard__desc"
							dangerouslySetInnerHTML={{ __html: c.desc }}
						/>
					</article>
				))}
			</div>

			<div className="openAll__ctaWrap">
				<button
					type="button"
					className="openAll__cta"
					onClick={() => navigate("/learning-content")}
				>
					現在大学に通っている方はこちら　→　社会人向けへ
				</button>
			</div>
		</div>
	);
};

function Icon({ name }) {
  const c = "currentColor";
  switch (name) {
    case "school":
      return (
        <svg width="22" height="22" viewBox="0 0 24 24">
          <path fill={c} d="M12 3L2 8l10 5l8-4v7h2V8z" />
          <path fill={c} d="M6 10v6l6 3l6-3v-6l-6 3z" />
        </svg>
      );
    case "cap":
      return (
        <svg width="22" height="22" viewBox="0 0 24 24">
          <path fill={c} d="M12 3 2 8l10 5 8-4-8-6z"/>
          <path fill={c} d="M6 12v3c0 2.2 3.6 4 6 4s6-1.8 6-4v-3l-6 3-6-3z"/>
        </svg>
      );
    default: // building
      return (
        <svg width="22" height="22" viewBox="0 0 24 24">
          <path fill={c} d="M4 22V5a2 2 0 0 1 2-2h8l6 6v13H4Zm12-10h4l-4-4v4Z" />
          <path fill={c} d="M7 8h2v2H7zm0 4h2v2H7zm0 4h2v2H7zm4-8h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2z" />
        </svg>
      );
  }
}

export default OpenSchoolSection;
